/* eslint-disable @typescript-eslint/no-explicit-any */

import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";

import { LoaderMatchers } from "../../loader-matcher";

export type TemplatePageMetadata = {
    title?: string | null;
    description?: string | null;
    titleSuffix?: "template" | "collection";
};

export type GetTemplateMetadataProps = {
    route: string;
    templates?: Template[];
    collections?: TemplateCollection[];
};

export const getTemplateMetadata = ({
    route,
    templates,
    collections
}: GetTemplateMetadataProps): TemplatePageMetadata | undefined => {
    const matcher = Object.values(LoaderMatchers).find((loader) =>
        loader.match.test(route)
    );

    if (!matcher) {
        throw new Error(`No metadata loader matcher found for route ${route}`);
    }

    const matchGroup = matcher.match.exec(route);
    let urlSlug = "";

    if (matchGroup && matchGroup.groups) {
        urlSlug = matchGroup.groups["urlSlug"] as string;
    }

    if (matcher.getPageMetadata) {
        return matcher.getPageMetadata({ templates, collections, urlSlug });
    }

    return;
};
